module.exports = __webpack_public_path__ + "ebcea49a4dfc04d313b0d4be03f72a44.png";